import type { Breakpoints } from '@mui/system';
import { Shape } from '@mui/system/createTheme/shape';

export const MAIN_FONT = 'Inter';
export const FONT_FAMILY = `"${MAIN_FONT}","Roboto","Helvetica","Arial",sans-serif`;

export const BREAKPOINTS: Breakpoints['values'] = {
  xxs: 0,
  xs: 576,
  sm: 768,
  md: 1012,
  lg: 1172,
  xl: 1364,
  xxl: 1504,
};

export const SPACING = 4;

export const SHAPE: Shape = {
  borderRadiusXs: 4,
  borderRadiusSm: 8,
  borderRadiusMd: 12,
  borderRadius: 16,
  borderRadiusLg: 18,
  borderRadiusXl: 20,
  borderRadiusXxl: 24,
};

export const SHAPE_BLOCKRAIL: Shape = {
  borderRadiusXs: 4,
  borderRadiusSm: 4,
  borderRadiusMd: 8,
  borderRadius: 12,
  borderRadiusLg: 12,
  borderRadiusXl: 12,
  borderRadiusXxl: 12,
}

export enum Themes {
  light = 'light',
  dark = 'dark',
}

export const NOTIFICATION_AUTO_HIDE_DURATION = 3000;
